import {Pipe, PipeTransform} from "@angular/core";
import {UntypedFormGroup} from "@angular/forms";

@Pipe({ name: 'value' })
export class FormValuePipe implements PipeTransform {

  transform(value: UntypedFormGroup, controlName: string, ...args: string[]): any | null {

    if (value) {
      const control = value.get(controlName);
      if (control) {
        if (args?.length === 1) {
          return control.value[args[0]];
        }
        return control.value;
      }
    }

    return null;
  }
}
